import { useEffect, useState } from "react";

import { useLayout } from "@/../_metronic/layout/core";

import { FaPlus } from "react-icons/fa";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { SisabPreliminaryReport } from "@/@types/app/sisabPreliminaryReport";
import { getUploadedReports } from "@/services/app/sisabPreliminaryReportService";

import { ModalUploadHealthInformationSystemForPrimaryCare } from "./ModalUploadHealthInformationSystemForPrimaryCare";
import { UploadedReportsTable } from "./UploadedReportsTable";

import "./styles.scss";

export function ImportSisabPreliminaryReportData() {
	const { setTitle } = useLayout();
	useEffect(() => {
		setTitle("IMPORTAÇÃO DE DADOS");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [show, setShow] = useState(false);
	const handleShowModal = () => setShow(true);
	const handleCloseModal = () => setShow(false);

	const [uploadedReports, setUploadedReports] = useState<SisabPreliminaryReport[]>([]);

	async function handleGetUploadedReports() {
		setUploadedReports(await getUploadedReports({ uf, ibgeCode, cnes }));
	}

	useEffect(() => {
		handleGetUploadedReports();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="p-2">
			<div className="row g-5 g-xl-8 pb-5">
				<div className="tab-content m-0">
					<div className="tab-pane fade show active" id="imports-content">
						<div className="col-xl-12">
							<ModalUploadHealthInformationSystemForPrimaryCare
								show={show}
								onHide={handleCloseModal}
								handleGetReports={handleGetUploadedReports}
							/>

							<Button
								variant="primary"
								className="mb-4 fs-7"
								onClick={handleShowModal}
							>
								<FaPlus className="me-2" />
								Adicionar novo relatório
							</Button>
						</div>
						<div className="col-xl-12 d-flex imports mt-8">
							<Card className="card-reports col-xl-8 me-2">
								<Card.Body>
									<div className="table-responsive">
										<UploadedReportsTable reports={uploadedReports} />
									</div>
								</Card.Body>
							</Card>
							<Card className="ms-6 pt-4">
								<Card.Header>
									<Card.Title className="fs-6 text-center">
										Entenda como baixar os arquivos diretamente do SISAB e
										importar para o Multisus
									</Card.Title>
								</Card.Header>
								<Card.Body></Card.Body>
							</Card>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
